export const fmtPrice = (n) => {
  if (n == null) return "—";
  return new Intl.NumberFormat("az-AZ", { maximumFractionDigits: 0 }).format(n);
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("az-AZ");
  } catch { return iso; }
};

// The API's LoginRequestDto.phoneNumber expects a bare digit string with the
// country code and no leading "+" (e.g. "994705075000"). Accept whatever the
// user types (+994 (70) 507-50-00, 0705075000, 705075000, ...) and normalize it.
export const normalizePhoneAZ = (raw = "") => {
  let digits = String(raw).replace(/\D/g, "");
  if (digits.startsWith("994")) return digits;
  if (digits.startsWith("0")) return `994${digits.slice(1)}`;
  if (digits.length === 9) return `994${digits}`;
  return digits;
};

// Display formatting: 994705075000 -> +994 (70) 507-50-00
export const fmtPhone = (digits = "") => {
  const d = String(digits).replace(/\D/g, "");
  const cc = d.startsWith("994") ? d.slice(3) : d;
  if (cc.length !== 9) return digits || "—";
  return `+994${cc.slice(0, 2)}${cc.slice(2, 5)}${cc.slice(5, 7)}${cc.slice(7, 9)}`;
};
